import { render } from "./rectorStudioList.vue?vue&type=template&id=263eca9e&scoped=true"
import script from "./rectorStudioList.vue?vue&type=script&lang=js"
export * from "./rectorStudioList.vue?vue&type=script&lang=js"

import "./rectorStudioList.vue?vue&type=style&index=0&id=263eca9e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263eca9e"]])

export default __exports__